import React, { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mockData';
import logo from './assets/logo.jpeg'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'Laptop Sales', href: '#sales' },
    { name: 'Spares', href: '#spares' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      {/* Top Bar */}
      <div className="bg-[#2E3C5B] text-white py-2 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-sm">
          <div className="flex flex-wrap gap-4 md:gap-6">
            <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-2 hover:text-[#E94B3C] transition-colors">
              <Phone size={16} />
              <span className="hidden sm:inline">{contactInfo.phone}</span>
            </a>
            <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 hover:text-[#E94B3C] transition-colors">
              <Mail size={16} />
              <span className="hidden md:inline">{contactInfo.email}</span>
            </a>
          </div>
          <Button 
            size="sm" 
            className="bg-[#E94B3C] hover:bg-[#d43d2c] text-white border-0 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            onClick={() => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  }}
          >
            Book a Service
          </Button>
        </div>
      </div>

      {/* Main Navigation */}
      <div 
        className={`bg-white transition-all duration-300 ${
          isScrolled ? 'shadow-lg py-2' : 'py-4'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src={logo}
              alt="EBR Systems & Services" 
              className="h-12 md:h-14 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-[#2E3C5B] font-medium hover:text-[#E94B3C] transition-colors duration-300 relative group"
              >
                {item.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#E94B3C] group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </nav>

<Button 
  onClick={() => {
    const address = "EBR SYSTEMS AND SERVICES 2/25, 1st main 1st cross Hanumanthpuram Srirampuram Bangalore 560021";
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(url, "_blank");
  }}
  className="hidden lg:flex bg-[#2E3C5B] hover:bg-[#1f2a3f] text-white border-0 shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
>
  <MapPin size={16} className="mr-2" />
  Find Store
</Button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-[#2E3C5B] p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
            <nav className="flex flex-col px-4 py-4 space-y-3">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#2E3C5B] font-medium hover:text-[#E94B3C] transition-colors py-2 px-3 hover:bg-gray-50 rounded-lg"
                >
                  {item.name}
                </a>
              ))}
<Button 
  onClick={() => {
    const address = "EBR SYSTEMS AND SERVICES 2/25, 1st main 1st cross Hanumanthpuram Srirampuram Bangalore 560021";
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(url, "_blank");
  }}
  className="bg-[#2E3C5B] hover:bg-[#1f2a3f] text-white w-full"
>
  <MapPin size={16} className="mr-2" />
  Find Store
</Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
